import i18n from '@/plugins/i18n';

/**
 * Find klassifizierung and return hierarchy string
 */
export const findParentKlassifizierung = (klassifizierung, children, prevText = '') => {
  for (let i = 0; i < children.length; i++) {
    const k = children[i];
    const text = prevText + k.name + ' - ';
    if (k.id === klassifizierung) {
      return text.substring(0, text.length - 3);
    } else {
      const fullText = findParentKlassifizierung(klassifizierung, k.children, text);
      if (fullText !== undefined) {
        return fullText;
      }
    }
  }
};

/**
 * Find klassifizierung and return whole object
 */
export const findKlassifizierung = (items, klassifizierung) => {
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.id === klassifizierung) {
      return item;
    } else if (item.children.length > 0) {
      const id = findKlassifizierung(item.children, klassifizierung);
      if (id !== undefined) {
        return id;
      }
    }
  }
};

/**
 * Get title of a cell with asterisk if mandatory
 */
export const getTitle = (cell, fallback) => {
  const tTitle = i18n.t(cell.title);
  if (tTitle) {
    return tTitle + (cell.mandatory && tTitle.slice(-1) != '*' ? '*' : '');
  } else if (fallback) {
    return i18n.t(fallback) + (cell.mandatory ? '*' : '');
  }
};

/**
 * Checks if cell is mandatory
 */
export const cellIsMandatory = (formInput, cell, isMultiplierCell) => {
  if (cell.key !== undefined) {
    // DANGER: The comparison was UDSwitchTextFieldCell (without _). With OP-8055 changed to ignore the extra check - as it lead to a mandatory additional field (below toggle),
    //         alltough the whole cell was decared to be optional
    //         However, this change could have a potential side-effect. So I leave this comment and the extra code (but ignored)
    if (cell.cellName !== undefined && cell.cellName === 'UDSwitchTextFieldCell_') {
      const switchCellKey = isMultiplierCell ? cell.key + '0' : cell.key;
      if (formInput[switchCellKey]) {
        if (cell.keyTextField !== undefined) {
          const textFieldCellKey = isMultiplierCell ? cell.keyTextField + '0' : cell.keyTextField;
          if (!formInput[textFieldCellKey]) {
            return true;
          }
        }
      }
    } else {
      if (cell.mandatory) {
        return true;
      }
    }
  }
  return false;
};

/**
 * Checks conditions for a specific item compared to a model
 */
export const conditionFilter = (formInput, item) => {
  //Check conditions
  if (item.conditions !== undefined) {
    const check = (c) => {
      const val = String(formInput[c.condition]);
      //conditionValue is a string so change val to string before checking
      return val === c.conditionValue;
    };

    if (item.conditionAnd === true) {
      return item.conditions.every((c) => check(c)) === true;
    } else {
      for (let i = 0; i < item.conditions.length; i++) {
        if (check(item.conditions[i])) {
          return true;
        }
      }
      return false;
    }
  }
  return true;
};
